import React from "react";
import SideBar from "../SideBar/SideBar";
import SemiHeader from "../SemiHeader/SemiHeader";
import SecSid from "../SecSid/SecSid";
import Details from "../Details/Details";
import Header from "../Header/Header";

const Home = () => {
  return (
    <div className="flex w-screen max-h-screen overflow-auto">
      <SideBar></SideBar>
      <div>
        <SemiHeader></SemiHeader>
        <div className="lg:flex">
          <SecSid></SecSid>
          <Details></Details>
        </div>
      </div>
    </div>
  );
};

export default Home;
